module.exports = __webpack_public_path__ + "static/medical-card-img-288c8115a45c39b44b36ebd08e28cada.png";